module.exports = __webpack_public_path__ + "static/img/6.5b9577c.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/qlxj/6.png
// module id = P+Ag
// module chunks = 5